import { SAVE_FAVORITE, DELETE_FAVORITE, GET_STATUS_FAVORITE } from '@/store/modules/bs_myp/actions'

export default {
  methods: {
    async addFavorite(menuNo) {
      const data = {
        itemType: 'favourite', 
        menuNo
      }
      return new Promise((resolve, reject) => {
        this.$store.dispatch(SAVE_FAVORITE, data).then(
          (response) => resolve(response), reject
        )
      })
    },
    async removeFavorite(idFavorite) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch(DELETE_FAVORITE, idFavorite).then(
          (response) => resolve(response), reject
        )
      })
    },
    async getFavoriteStatus(menuNo, serviceType) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch(GET_STATUS_FAVORITE, { menuNo, serviceType }).then(
          (response) => resolve(response), reject
        )
      })
    },
    async addFavoriteTour(menuNo) {
      const data = {
        itemType: 'favourite', 
        menuNo,
        serviceType: 'tour'
      }
      return new Promise((resolve, reject) => {
        this.$store.dispatch(SAVE_FAVORITE, data).then(
          (response) => resolve(response), reject
        )
      })
    }
  }
}